import { Grid } from '@mui/material'
import { styled } from '@mui/system'
import Typography from '../../../atoms/typography'
import BHActionWishList from '../../../molecules/action-wish-list'
import BHProductPrice from '../../../molecules/product-price'
import Chip from '../../../molecules/chip'

const shouldForwardProp = (prop) => prop !== 'hasCollection'

const TitleWrapper = styled(Grid, { shouldForwardProp })`
	display: flex;
	align-items: baseline;
	margin-bottom: ${({ theme }) => theme.spacing(3)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		margin-top: 0px;
	}
	${({ hasCollection }) => (hasCollection ? `flex-wrap: wrap;` : null)}
`

const OutOfStockLabel = styled(Chip)`
	text-transform: uppercase;
	font-size: var(--font-size-body1);
	border: 1px solid var(--color-primary);
	background: rgba(255, 255, 255, 0.3);
	backdrop-filter: blur(100px);
`

const CollectionLabel = styled(Typography)`
	order: 1;
	margin-bottom: ${({ theme }) => theme.spacing(2)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		flex: 1 0 100%;
	}
`

const Title = styled(Typography, { shouldForwardProp })`
	${({ hasCollection }) => (hasCollection ? `flex: 1 0 100%; order: 3;` : null)}
	${({ theme }) => theme.breakpoints.up('sm')} {
		flex: 1 0 calc(100% - 40px);
		${({ hasCollection }) => (hasCollection ? `order: 2;` : null)}
	}
`

const Name = styled(Typography)`
	${({ theme }) => theme.typography.h1}
`
const Sku = styled(Typography)``

const ActionWishList = styled(BHActionWishList)`
	order: 2;
	margin-top: ${({ theme }) => theme.spacing(1)};
	margin-bottom: ${({ theme }) => theme.spacing(2)};
	margin-left: auto;
	margin-right: 0;
	${({ theme }) => theme.breakpoints.up('sm')} {
		flex: 1 0 40px;
		margin-bottom: 0;
	}
`

const ProductPrice = styled(BHProductPrice)`
	font-size: ${({ theme }) => theme.typography.pxToRem(16)};
	margin-bottom: ${({ theme }) => theme.spacing(1)};
	${({ theme }) => theme.breakpoints.up('md')} {
		flex-direction: row;
	}
	.old-price,
	.base-price,
	.discount-percentage {
		margin-right: ${({ theme }) => theme.spacing(2)};
	}
`

const VatLabel = styled(Typography)`
	color: ${({ theme }) => theme.palette.grey.main};
`

export { CollectionLabel, TitleWrapper, Title, ActionWishList, ProductPrice, VatLabel, Sku, Name, OutOfStockLabel }
